export function getBaseURL() {
  var origin = window.location.origin;

  if (origin.indexOf("localhost") !== -1) {
    return "https://uat-api.vidyuttech.com";
  } else if (
    origin.indexOf("uat.vidyuttech.com") !== -1 ||
    origin.indexOf("hawkeye-uat.vidyuttech.com") !== -1
  ) {
    return "https://uat-api.vidyuttech.com";
  } else if (origin.indexOf("hawkeye.vidyuttech.com") !== -1) {
    return "https://prod-api.vidyuttech.com";
  }
}
export const getAuthorization = () => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get("token");
  return token;
};
